
























import { Component } from 'vue-property-decorator';
import AnalyzeServices from '@/services/analyze';
import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import { sleep } from '@/libs/util';
import { Action } from 'vuex-class';
import topHeader from './topHeader.vue';
import digitalFlop from './digitalFlop.vue';
import rankingBoard from './rankingBoard.vue';
import roseChart from './roseChart.vue';
import scrollBoard from './scrollBoard.vue';
import cards from './cards.vue';
@Component({
  components: { topHeader, digitalFlop, rankingBoard, roseChart, scrollBoard, cards }
})
export default class DataView extends mixins(DictMixin) {
  @Action('getDictList') getDictList: any;

  analyzeSrv = new AnalyzeServices();
  indData: any = [];

  created() {
    this.getOverView();
  }

  async getOverView() {
    let res = await this.analyzeSrv.getOverview({
      groupByField: 'ind_first_level',
      whereField: '',
      condition: '',
      type: 'all',
      dictCode: 'DICT_JOURNEY_SCENE'
    });
    this.packData(res);
  }

  async packData(res: any) {
    if (!this.SYS_DICT.DICT_JOURNEY_SCENE) {
      await this.getDictList();
      await sleep(100);
      this.packData(res);
      return false;
    }
    this.DICT_JOURNEY_SCENE.forEach((v: any) => {
      let data = res.find((r: any) => r.dictItemCode === v.value);
      let value = data?.count ?? 0;
      this.indData.push({
        title: v.label,
        value,
        number: {
          number: [value],
          content: '{nt}',
          textAlign: 'right',
          style: {
            fill: '#4d99fc',
            fontWeight: 'bold'
          }
        },
        unit: '指标'
      });
    });
  }
}
